<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row dense class="pt-6">
      <v-col cols="12" sm="9" md="10" lg="10">
        <v-text-field class="search-field" v-model="search" prepend-icon="mdi-magnify" label="Search..." single-line
          solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3" md="2" lg="2">
        <ul class="mt-0">
          <li><span>Total Investors</span><span>{{ mammanagerinvestors?.totalInvestors }}</span></li>
          <!-- <li><span>Running</span><span>{{ mammanagerinvestors?.totalRunningOrders }}</span></li> -->
        </ul>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :search="search" :headers="headers" :items="mammanagerinvestors?.transformedInvestors"
              :loading="isLoading" :items-per-page="6">
              <template v-slot:item.status="{ item }">
                <div class="status-cell">
                  <v-switch :disabled="$canRoute('managers') !== 1" :input-value="Boolean(item.status)"
                    @change="handleStatus(item)" inset color="#039de9" :ripple="false" hide-details>
                    <template v-slot:label>
                      <span class="account-status">
                        {{ item.status === 1 ? 'Active' : 'Inactive' }}
                      </span>
                    </template>
                  </v-switch>
                </div>
              </template>

              <template v-slot:item.details="{ item }">
                <!-- <v-icon :disabled="$canRoute('managers') !== 1" @click="handleRemove(item)" color="#FF567F" class="mx-2"
                  small style="cursor: pointer;">
                  mdi-trash-can-outline</v-icon> -->
                <v-icon :disabled="$canRoute('managers') !== 1" @click="openDeleteDialog(item)" color="#FF567F"
                  class="mx-2" small style="cursor: pointer;">
                  mdi-trash-can-outline
                </v-icon>
                <router-link :to="`/trade-master-investors?account=${item.login}`">
                  <v-icon v-if="item.is_trade_master == 1" @click="investorDetails(item)" color="#039de9" class="mx-2"
                    small style="cursor: pointer;"> mdi-eye-outline</v-icon>
                </router-link>
              </template>


            </v-data-table>
            <v-dialog v-model="deleteDialog" max-width="420">
              <v-card>
                <v-card-title class="headline">
                  Confirm Delete
                </v-card-title>

                <v-card-text>
                  Are you sure you want to delete this investor?
                  <br />
                  <strong>Account:</strong> {{ selectedItem?.login }}
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn text @click="deleteDialog = false">
                    Cancel
                  </v-btn>

                  <v-btn color="red" text @click="confirmDelete">
                    Yes, Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { MAM__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: '',
      managerAccount: '',
      deleteDialog: false,
      selectedItem: null,
      headers: [
        { text: "Name", value: "name" },
        { text: "Login", value: "login" },
        // { text: "Group", value: "group" },
        { text: "Balance", value: "balance" },
        { text: "Equity", value: "equity" },
        { text: "Margin", value: "margin" },
        // { text: "Running Order", value: "running_orders" },
        { text: "Account Status", value: "status" },
        { text: "Action", value: "details" },
      ],
    };
  },

  computed: {
    ...mapState("mam", ["mammanagerinvestors", "isLoading"]),
  },

  methods: {
    ...mapActions("mam", [MAM__ACTIONS.GETMAMMANAGERINVESTORS, MAM__ACTIONS.CHANGEINVESTORSTATUS, MAM__ACTIONS.REMOVEINVESTOR]),

    // handleStatus(item) {
    //   const newStatus = !item.status ? 1 : 0;

    //   this[MAM__ACTIONS.CHANGEINVESTORSTATUS]({
    //     id: item.id,
    //     status: newStatus,
    //     account: item.login,
    //     manager_account: this.managerAccount
    //   })
    // },
    openDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    confirmDelete() {
      this[MAM__ACTIONS.REMOVEINVESTOR]({
        id: this.selectedItem.id,
        account: this.selectedItem.login,
        manager_account: this.managerAccount
      });

      this.deleteDialog = false;
      this.selectedItem = null;
    },

    handleStatus(item) {
      const newStatus = item.status ? 0 : 1;

      this[MAM__ACTIONS.CHANGEINVESTORSTATUS]({
        id: item.id,
        status: newStatus,
        account: item.login,
        manager_account: this.managerAccount
      });
    },

    handleRemove(item) {
      this[MAM__ACTIONS.REMOVEINVESTOR]({
        id: item.id,
        account: item.login,
        manager_account: this.managerAccount
      })
    },

    investorDetails(item) {

    },
  },

  async mounted() {
    this.managerAccount = this.$route.query.account
    this[MAM__ACTIONS.GETMAMMANAGERINVESTORS](this.$route.query.account);
  },

}

</script>


<style>
.account-status {
  text-align: center !important;
  font-weight: 400;
  font-size: 12px;
  line-height: 26px;
  color: #b4c2d1;
}

.status-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-input--switch .v-label {
  margin-left: 6px;
  /* reduce default gap */
}
</style>